import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ContactUs from "./pages/ContactUs";
import CarDetails from "./common/carDetails";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

const App = () => {
  return (
    <Router>
      <Helmet>
        <title>True Choice Car's - Best Used Cars</title>
        <meta
          name="description"
          content="Buy high-quality used cars at True Choice Car's. Browse by make, model, or budget."
        />
        <meta
          name="keywords"
          content="used cars, second hand cars, buy car Nagpur, True Choice Cars"
        />
        <link rel="canonical" href="https://truechoicecars.com/" />
      </Helmet>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/car-details/:id" element={<CarDetails />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
